import React from "react";

import "./style.css";

export const AlignCenterEnd = ({ children }) => {
  return (
    <div className={"align-center-end"} style={{}}>
      {children}
    </div>
  );
};
